var _defs, _line, _line2, _path, _path2, _rect, _path3, _path4, _path5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab9c5401-eda4-40bb-806b-162000d89d90",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e7e0b89b-86f2-47f2-ae13-b78c1de0bace,.ec9355c6-7c7f-4d30-b3f7-729caa3e30af{fill:none;}.ec9355c6-7c7f-4d30-b3f7-729caa3e30af{stroke:#645346;}.b6cafb8e-adc6-45db-9b46-7620a4667e86,.e7e0b89b-86f2-47f2-ae13-b78c1de0bace,.ec9355c6-7c7f-4d30-b3f7-729caa3e30af{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b6cafb8e-adc6-45db-9b46-7620a4667e86,.e7e0b89b-86f2-47f2-ae13-b78c1de0bace{stroke:#8e8e8e;}.ac61367f-5be0-464a-89fa-100e6734dfed,.b6cafb8e-adc6-45db-9b46-7620a4667e86{fill:#ea3d3e;}.f423aecf-e717-4ad5-854f-7d1fa6434df1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ppt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ec9355c6-7c7f-4d30-b3f7-729caa3e30af",
    x1: 45.3,
    y1: 41.1,
    x2: 32.8,
    y2: 41.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ec9355c6-7c7f-4d30-b3f7-729caa3e30af",
    x1: 45.3,
    y1: 50.9,
    x2: 32.8,
    y2: 50.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e7e0b89b-86f2-47f2-ae13-b78c1de0bace",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b6cafb8e-adc6-45db-9b46-7620a4667e86",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ac61367f-5be0-464a-89fa-100e6734dfed",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f423aecf-e717-4ad5-854f-7d1fa6434df1",
    d: "M44.2,62.3h2.5a4.6,4.6,0,0,1,2.9.8,2.9,2.9,0,0,1,.8,2.1,3.2,3.2,0,0,1-.7,2.2,4.5,4.5,0,0,1-3.1,1.1H45.5v4H44.2Zm1.3,4.9h1.1c1.6,0,2.5-.7,2.5-2.1s-.9-2-2.3-2H45.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f423aecf-e717-4ad5-854f-7d1fa6434df1",
    d: "M52.2,62.3h2.5a4.3,4.3,0,0,1,2.8.8,2.6,2.6,0,0,1,.9,2.1,3.3,3.3,0,0,1-.8,2.2,4.3,4.3,0,0,1-3.1,1.1h-1v4H52.2Zm1.3,4.9h1.1c1.5,0,2.5-.7,2.5-2.1s-.9-2-2.4-2H53.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f423aecf-e717-4ad5-854f-7d1fa6434df1",
    d: "M62.1,63.3H59V62.2h7.5v1.1H63.4v9H62.1Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ec9355c6-7c7f-4d30-b3f7-729caa3e30af",
    x: 50.2,
    y: 41.1,
    width: 10.7,
    height: 9.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.a73cad75bbd7db6f09c1a0c643623cbb.svg";
export { ForwardRef as ReactComponent };